import { ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getSignInAsUserEmail } from "@api/fetch";
import { getToken } from "../msalConfig";

export const authLink: ApolloLink = setContext(async (req, { headers }) => {
  const token = await getToken();

  const signInAsUserEmail = getSignInAsUserEmail();

  return {
    headers: {
      ...headers,
      "X-OPERATION-NAME": req.operationName || "",
      authorization: token ? `Bearer ${token}` : "",
      "X-POSE-USER": signInAsUserEmail || ""
    }
  };
});
